import * as React from "react";
import { Account } from "@/types";
import { RequestDetailsField } from "@/components/molecules";
import { NotAvailable } from "./NotAvailable";
import { readableAccountNextSteps, readableAccountType } from "@/utils/accounts";

export type QuilterAccountRequestProps = { account: Account };

export const QuilterAccountRequest: React.FC<QuilterAccountRequestProps> = ({ account }) => {
  return (
    <>
      <RequestDetailsField label="Account Type">
        {readableAccountType(account.accountType, <NotAvailable />)}
      </RequestDetailsField>
      <RequestDetailsField label="head Account number">
        {account.accountNumber ?? <NotAvailable />}
      </RequestDetailsField>
      <RequestDetailsField label="Notifier request">
        {readableAccountNextSteps(account.nextSteps, account.serviceProvider?.serviceProviderType)}
      </RequestDetailsField>
      <RequestDetailsField label="Sub Account Number">
        {account.holderNumber ?? <NotAvailable />}
      </RequestDetailsField>
      <RequestDetailsField label="Did the death occur in the UK?">
        {account?.isPlaceOfDeathUk ? "Yes" : "No"}
      </RequestDetailsField>
      {account?.isPlaceOfDeathUk && (
        <RequestDetailsField label="Assets over £100k?">
          {account?.assetsValueAboveThreshold ? "Yes" : "No"}
        </RequestDetailsField>
      )}
    </>
  );
};
